(function($) {
  $(document).ready(function() {
    // Display directory content

    $('input[type="radio"]#taxes-yes, input[type="radio"]#taxes-no').click(
      function() {
        var inputValue = $(this).attr('value');
        if (inputValue == 'taxes-yes') {
          $('.taxes-numbers-content').show();
        } else {
          $('.taxes-numbers-content').hide();
        }
      },
    );

    jQuery.validator.addMethod(
      'validate_email',
      function(value, element) {
        if (
          /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(
            value,
          )
        ) {
          return true;
        } else {
          return false;
        }
      },
      jQuery.validator.messages.email,
    );

    $('#receipt-form').validate({
      errorElement: 'span',
      rules: {
        'new-receipt[1][client_email]': {
          required: true,
          validate_email: true,
        },
      },
    });

    $('.form-receipt-submit').click(function(event) {
      event.preventDefault();
      var validation = $('#receipt-form').valid();

      if (!validation) {
        $('.alert-message').show();
        $('.alert-message-success').hide();
        $(window).scrollTop(0);
      } else {
        $('.alert-message').hide();
      }

      if (validation) {
        $('.waiting').addClass('show');
        $('#receipt-form').submit();
      }
    });

    $('.receipt__button--resend').click(function(event) {
      event.preventDefault();

      if ($(this).hasClass('receipt__button--resend-client')) {
        $('.to-field').val('client');
      } else if ($(this).hasClass('receipt__button--resend-user')) {
        $('.to-field').val('user');
      }
      $('.alert-message').hide();
      $('.waiting').addClass('show');
      $(this)
        .parent()
        .parent()
        .parent()
        .submit();
    });

    /**
     * Signature
     */
    if ($('body').hasClass('page-template-template-receipts')) {
      (function() {
        window.requestAnimFrame = (function(callback) {
          return (
            window.requestAnimationFrame ||
            window.webkitRequestAnimationFrame ||
            window.mozRequestAnimationFrame ||
            window.oRequestAnimationFrame ||
            window.msRequestAnimaitonFrame ||
            function(callback) {
              window.setTimeout(callback, 1000 / 60);
            }
          );
        })();

        var canvas = document.getElementById('sig-canvas');
        var ctx = canvas.getContext('2d');
        ctx.strokeStyle = '#222222';
        ctx.lineWidth = 4;

        var drawing = false;
        var mousePos = {
          x: 0,
          y: 0,
        };
        var lastPos = mousePos;

        canvas.addEventListener(
          'mousedown',
          function(e) {
            drawing = true;
            lastPos = getMousePos(canvas, e);
          },
          false,
        );

        canvas.addEventListener(
          'mouseup',
          function(e) {
            drawing = false;
          },
          false,
        );

        canvas.addEventListener(
          'mousemove',
          function(e) {
            mousePos = getMousePos(canvas, e);
          },
          false,
        );

        // Add touch event support for mobile
        canvas.addEventListener('touchstart', function(e) {}, false);

        canvas.addEventListener(
          'touchmove',
          function(e) {
            var touch = e.touches[0];
            var me = new MouseEvent('mousemove', {
              clientX: touch.clientX,
              clientY: touch.clientY,
            });
            canvas.dispatchEvent(me);
          },
          false,
        );

        canvas.addEventListener(
          'touchstart',
          function(e) {
            mousePos = getTouchPos(canvas, e);
            var touch = e.touches[0];
            var me = new MouseEvent('mousedown', {
              clientX: touch.clientX,
              clientY: touch.clientY,
            });
            canvas.dispatchEvent(me);
          },
          false,
        );

        canvas.addEventListener(
          'touchend',
          function(e) {
            var me = new MouseEvent('mouseup', {});
            canvas.dispatchEvent(me);
          },
          false,
        );

        function getMousePos(canvasDom, mouseEvent) {
          var rect = canvasDom.getBoundingClientRect();
          return {
            x: mouseEvent.clientX - rect.left,
            y: mouseEvent.clientY - rect.top,
          };
        }

        function getTouchPos(canvasDom, touchEvent) {
          var rect = canvasDom.getBoundingClientRect();
          return {
            x: touchEvent.touches[0].clientX - rect.left,
            y: touchEvent.touches[0].clientY - rect.top,
          };
        }

        function renderCanvas() {
          if (drawing) {
            ctx.moveTo(lastPos.x, lastPos.y);
            ctx.lineTo(mousePos.x, mousePos.y);
            ctx.stroke();
            lastPos = mousePos;
          }
        }

        // Prevent scrolling when touching the canvas
        document.body.addEventListener(
          'touchstart',
          function(e) {
            if (e.target == canvas) {
              e.preventDefault();
            }
          },
          false,
        );
        document.body.addEventListener(
          'touchend',
          function(e) {
            if (e.target == canvas) {
              e.preventDefault();
            }
          },
          false,
        );
        document.body.addEventListener(
          'touchmove',
          function(e) {
            if (e.target == canvas) {
              e.preventDefault();
            }
          },
          false,
        );

        (function drawLoop() {
          requestAnimFrame(drawLoop);
          renderCanvas();
        })();

        function clearCanvas() {
          canvas.width = canvas.width;
        }

        // Set up the UI
        var sigImage = document.getElementById('sig-image');
        var clearBtn = document.getElementById('sig-clearBtn');
        var cancelBtn = document.getElementById('sig-cancelBtn');
        var submitBtn = document.getElementById('sig-submitBtn');
        clearBtn.addEventListener(
          'click',
          function(e) {
            clearCanvas();
            $('#signature-data').val('');
          },
          false,
        );
        submitBtn.addEventListener(
          'click',
          function(e) {
            var dataUrl = canvas.toDataURL();

            console.log(dataUrl);

            if (
              dataUrl != 'data:image/png;base64,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' && 
              dataUrl != 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASwAAACgCAYAAAC2eFFiAAAAAXNSR0IArs4c6QAABKtJREFUeF7t1AEJAAAMAsHZv/RyPNwSyDncOQIECEQEFskpJgECBM5geQICBDICBitTlaAECBgsP0CAQEbAYGWqEpQAAYPlBwgQyAgYrExVghIgYLD8AAECGQGDlalKUAIEDJYfIEAgI2CwMlUJSoCAwfIDBAhkBAxWpipBCRAwWH6AAIGMgMHKVCUoAQIGyw8QIJARMFiZqgQlQMBg+QECBDICBitTlaAECBgsP0CAQEbAYGWqEpQAAYPlBwgQyAgYrExVghIgYLD8AAECGQGDlalKUAIEDJYfIEAgI2CwMlUJSoCAwfIDBAhkBAxWpipBCRAwWH6AAIGMgMHKVCUoAQIGyw8QIJARMFiZqgQlQMBg+QECBDICBitTlaAECBgsP0CAQEbAYGWqEpQAAYPlBwgQyAgYrExVghIgYLD8AAECGQGDlalKUAIEDJYfIEAgI2CwMlUJSoCAwfIDBAhkBAxWpipBCRAwWH6AAIGMgMHKVCUoAQIGyw8QIJARMFiZqgQlQMBg+QECBDICBitTlaAECBgsP0CAQEbAYGWqEpQAAYPlBwgQyAgYrExVghIgYLD8AAECGQGDlalKUAIEDJYfIEAgI2CwMlUJSoCAwfIDBAhkBAxWpipBCRAwWH6AAIGMgMHKVCUoAQIGyw8QIJARMFiZqgQlQMBg+QECBDICBitTlaAECBgsP0CAQEbAYGWqEpQAAYPlBwgQyAgYrExVghIgYLD8AAECGQGDlalKUAIEDJYfIEAgI2CwMlUJSoCAwfIDBAhkBAxWpipBCRAwWH6AAIGMgMHKVCUoAQIGyw8QIJARMFiZqgQlQMBg+QECBDICBitTlaAECBgsP0CAQEbAYGWqEpQAAYPlBwgQyAgYrExVghIgYLD8AAECGQGDlalKUAIEDJYfIEAgI2CwMlUJSoCAwfIDBAhkBAxWpipBCRAwWH6AAIGMgMHKVCUoAQIGyw8QIJARMFiZqgQlQMBg+QECBDICBitTlaAECBgsP0CAQEbAYGWqEpQAAYPlBwgQyAgYrExVghIgYLD8AAECGQGDlalKUAIEDJYfIEAgI2CwMlUJSoCAwfIDBAhkBAxWpipBCRAwWH6AAIGMgMHKVCUoAQIGyw8QIJARMFiZqgQlQMBg+QECBDICBitTlaAECBgsP0CAQEbAYGWqEpQAAYPlBwgQyAgYrExVghIgYLD8AAECGQGDlalKUAIEDJYfIEAgI2CwMlUJSoCAwfIDBAhkBAxWpipBCRAwWH6AAIGMgMHKVCUoAQIGyw8QIJARMFiZqgQlQMBg+QECBDICBitTlaAECBgsP0CAQEbAYGWqEpQAAYPlBwgQyAgYrExVghIgYLD8AAECGQGDlalKUAIEDJYfIEAgI2CwMlUJSoCAwfIDBAhkBAxWpipBCRAwWH6AAIGMgMHKVCUoAQIGyw8QIJARMFiZqgQlQMBg+QECBDICBitTlaAECBgsP0CAQEbAYGWqEpQAAYPlBwgQyAgYrExVghIgYLD8AAECGQGDlalKUAIEDJYfIEAgI2CwMlUJSoCAwfIDBAhkBAxWpipBCRAwWH6AAIGMgMHKVCUoAQIPBfEAoeZvv+sAAAAASUVORK5CYII=' &&
              dataUrl != 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAPoAAACgCAYAAAAl+XGsAAAAAXNSR0IArs4c6QAAA+JJREFUeF7t0wEBAAAIwjDtX9oefjZgyI4jQOC9wL5PKCABAmPonoBAQMDQAyWLSMDQ/QCBgIChB0oWkYCh+wECAQFDD5QsIgFD9wMEAgKGHihZRAKG7gcIBAQMPVCyiAQM3Q8QCAgYeqBkEQkYuh8gEBAw9EDJIhIwdD9AICBg6IGSRSRg6H6AQEDA0AMli0jA0P0AgYCAoQdKFpGAofsBAgEBQw+ULCIBQ/cDBAIChh4oWUQChu4HCAQEDD1QsogEDN0PEAgIGHqgZBEJGLofIBAQMPRAySISMHQ/QCAgYOiBkkUkYOh+gEBAwNADJYtIwND9AIGAgKEHShaRgKH7AQIBAUMPlCwiAUP3AwQCAoYeKFlEAobuBwgEBAw9ULKIBAzdDxAICBh6oGQRCRi6HyAQEDD0QMkiEjB0P0AgIGDogZJFJGDofoBAQMDQAyWLSMDQ/QCBgIChB0oWkYCh+wECAQFDD5QsIgFD9wMEAgKGHihZRAKG7gcIBAQMPVCyiAQM3Q8QCAgYeqBkEQkYuh8gEBAw9EDJIhIwdD9AICBg6IGSRSRg6H6AQEDA0AMli0jA0P0AgYCAoQdKFpGAofsBAgEBQw+ULCIBQ/cDBAIChh4oWUQChu4HCAQEDD1QsogEDN0PEAgIGHqgZBEJGLofIBAQMPRAySISMHQ/QCAgYOiBkkUkYOh+gEBAwNADJYtIwND9AIGAgKEHShaRgKH7AQIBAUMPlCwiAUP3AwQCAoYeKFlEAobuBwgEBAw9ULKIBAzdDxAICBh6oGQRCRi6HyAQEDD0QMkiEjB0P0AgIGDogZJFJGDofoBAQMDQAyWLSMDQ/QCBgIChB0oWkYCh+wECAQFDD5QsIgFD9wMEAgKGHihZRAKG7gcIBAQMPVCyiAQM3Q8QCAgYeqBkEQkYuh8gEBAw9EDJIhIwdD9AICBg6IGSRSRg6H6AQEDA0AMli0jA0P0AgYCAoQdKFpGAofsBAgEBQw+ULCIBQ/cDBAIChh4oWUQChu4HCAQEDD1QsogEDN0PEAgIGHqgZBEJGLofIBAQMPRAySISMHQ/QCAgYOiBkkUkYOh+gEBAwNADJYtIwND9AIGAgKEHShaRgKH7AQIBAUMPlCwiAUP3AwQCAoYeKFlEAobuBwgEBAw9ULKIBAzdDxAICBh6oGQRCRi6HyAQEDD0QMkiEjB0P0AgIGDogZJFJGDofoBAQMDQAyWLSMDQ/QCBgIChB0oWkYCh+wECAQFDD5QsIgFD9wMEAgKGHihZRAKG7gcIBAQMPVCyiAQM3Q8QCAgYeqBkEQkYuh8gEBAw9EDJIhI4OBkAoeuqA/gAAAAASUVORK5CYII='
            ) {
              sigImage.setAttribute('src', dataUrl);
              $('#sig-image').removeClass('d-none');
              $('#signature-data').val(dataUrl);
              $('.current-signature').removeClass('d-none');
              $('.new-signature').addClass('d-none');
              $('#sig-cancelBtn').removeClass('d-none');
            }
          },
          false,
        );

        cancelBtn.addEventListener('click', function (e) {
          e.preventDefault();
          $('.current-signature').removeClass('d-none');
          $('.new-signature').addClass('d-none');
          clearCanvas();
          $('#signature-data').val('');
        });
      })();
    }

    resizeCanvas();

    $(window).on('resize', function() {
      resizeCanvas();
    });

    function resizeCanvas() {
      if (window.innerWidth < 370) {
        $('#sig-canvas').attr('width', 250);
      } else if (window.innerWidth >= 370 && window.innerWidth <= 700) {
        $('#sig-canvas').attr('width', 300);
      } else {
        $('#sig-canvas').attr('width', 620);
      }
    }

    $('#sig-edit-button').on('click', function (e) {
      e.preventDefault();
      $('.current-signature').addClass('d-none');
      $('.new-signature').removeClass('d-none');
    });

    function receiptShowMore(button) {
      var show = button.attr('data-show');
      var receipt = button
        .parent()
        .parent()
        .parent();
      var details = receipt.find('.receipt__details').first();
      var scrollOffset = $('.site-header').innerHeight();

      if (show === 'more') {
        details.removeClass('receipt__details--hidden');
        button.attr('data-show', 'less');
      } else {
        details.addClass('receipt__details--hidden');
        button.attr('data-show', 'more');
      }

      $([document.documentElement, document.body])
        .stop()
        .animate(
          {
            scrollTop: receipt.offset().top - scrollOffset,
          },
          500,
        );
    }

    $('.receipt__button').each(function() {
      $(this).click(function() {
        receiptShowMore($(this));
      });
    });

    /**
     * Client Selector
     */
    $('#client-select').on('change', function () {
      var clientSelect = $(this);
      var clientSelectOption = clientSelect.find(':selected');
      var saveNewClient = $('#save-client');
      var idClient = $('#id-client');
      var nameClient = $('#name-client');
      var emailClient = $('#email-client');
      var addressClient = $('#address-client');

      if (clientSelect.val() === 'new' || clientSelect.val() === '') {
        // New Client
        saveNewClient.show();
        handleClientSelectFieldContent(idClient);
        handleClientSelectFieldContent(nameClient);
        handleClientSelectFieldContent(emailClient);
        handleClientSelectFieldContent(addressClient);

      } else if (clientSelect.val() !== '') {
        // Existing Client
        saveNewClient.hide();
        handleClientSelectFieldContent(idClient, clientSelectOption.attr('data-id'));
        handleClientSelectFieldContent(nameClient, clientSelectOption.attr('data-name'));
        handleClientSelectFieldContent(emailClient, clientSelectOption.attr('data-email'));
        handleClientSelectFieldContent(addressClient, clientSelectOption.attr('data-address'));
      }
    });

    function handleClientSelectFieldContent(element = null, value = '', disabled = false) {
      element.val(value).prop('disabled', disabled);

      if (value) {
        element.prev('label').addClass('input-focus');
      } else {
        element.prev('label').removeClass('input-focus');
      }
    }
  });
})(jQuery);
